import React from "react";
import styles from "./Sponsors.module.css";
import { useColorModeValue } from "../../hooks/useColorModeValue";
import { useThemeContext } from "../../theme/ThemeProvider";

export const Sponsors = () => {
  const { theme } = useThemeContext();

  const handleHover = (e) =>{
    e.currentTarget.style.backgroundColor = theme==="dark"?"#47484d":"#aeb1b5";
  }

  const handleOut = (e) =>{
    e.currentTarget.style.backgroundColor = theme==="dark"?"#313235":"#e8eaed";
  }

  return (
    <div className={styles.sponsorContainer}>
      <div id="sponsors" className={styles.sponsorHeading}>Our Sponsors</div>
      <div className={styles.sponsorFlexContainer}>
        <div className={styles["goldsponsor"]}>
          <a href="https://www.datacamp.com/"
            className={useColorModeValue(false,true)?`${styles.StreamDark} ${styles.Stream}`:styles.Stream}
            style={{ backgroundColor: useColorModeValue("#e8eaed", "#313235") }}
            onMouseOver={handleHover}
            onMouseOut={handleOut}

          >
            <div
              className={styles["gold"]}
              style={{ color: useColorModeValue("white", "black") }}
            >
              Primary Sponsor
            </div>
          </a>
        </div>
       
      </div>
    </div>
  );
};
